import React, { useEffect } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from '@/components/ui/toaster';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useVisitorTracking } from '@/hooks/useVisitorTracking';

type LayoutProps = {
  children: React.ReactNode;
};

export const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isFrench = location.pathname.startsWith('/fr');
  
  useVisitorTracking();
  
  // Force language change based on route
  useEffect(() => {
    const lang = isFrench ? 'fr' : 'en';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    // Update HTML lang attribute
    document.documentElement.lang = lang;
  }, [isFrench, i18n]);
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <motion.main 
        className="flex-1 w-full"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.main>
      <Footer />
      <Toaster />
    </div>
  );
};
